import { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
// import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { obtenerListaCliente } from "../../../api/api-cliente";
import { obtenerGeocercasPorIdGrupoGeocerca } from "../../../api/api-grupo-geocerca";
import MapaGeocercasCliente from "../../../components/mapa-geocercas-cliente";
import SwitchComponent from "../../../components/switch";
// import { obtenerListaGrupoGeocerca } from "../../../api/api-grupo-geocerca";

let $ = window.$;

export default function MapaClientePage
  () {
  const { t } = useTranslation();
  // const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);

  // const [idGrupoGeocerca, setIdGrupoGeocerca] = useState(null);
  const [listaGeocercas, setListaGeocercas] = useState([]);

  const [listaClientes, setListaClientes] = useState([]);
  const [mostrarEtiquetasMarcadores, setMostrarEtiquetasMarcadores] = useState(true);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objEnviar = {};
      // objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      /*let obj = {};
      obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      // let permiso = null;
      let lista = [];

      lista = await obtenerListaCliente(objEnviar, false, t);
      // console.log('lista');
      // console.log(lista);
      setListaClientes(lista);


      // const grupoGeocercaResponse = await obtenerListaGrupoGeocerca({ habilitado: 1 }, false, t);
      // if (Array.isArray(grupoGeocercaResponse) && grupoGeocercaResponse.length > 0) {
      //   setIdGrupoGeocerca(grupoGeocercaResponse[0].idGrupo);
      // }
      const geocercasResponse = await obtenerGeocercasPorIdGrupoGeocerca();
      // console.log('geocercasResponse');
      // console.log(geocercasResponse);
      if (geocercasResponse.error === false && Array.isArray(geocercasResponse.body) && geocercasResponse.body.length > 0) {
        setListaGeocercas(geocercasResponse.body);
      }

      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_mapa_de_clientes")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_visualiza_el_mapa_de_clientes")}</p>
            </div>
            <div className="flex items-center">
              <SwitchComponent
                checked={mostrarEtiquetasMarcadores}
                onChange={setMostrarEtiquetasMarcadores}
                label={t("label_mostrar_etiquetas_clientes_mapa")}
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
              <MapaGeocercasCliente
                geocercas={listaGeocercas}
                listaClientes={listaClientes}
                mostrarEtiquetasMarcadores={mostrarEtiquetasMarcadores}
              />
            </div>
          </div>
          <br />
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarCliente render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
